import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { ProfileManageGuard } from '@desquare/guards';
import { ProfileListComponent } from './profile-list/profile-list.component';

const routes: Routes = [
  {
    path: 'profiles',
    component: ProfileListComponent,
    canLoad: [ProfileManageGuard],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class ProfileRoutingModule {}
